/* Kamoflaj Field - kamo-extra.js: collection panels, counters, search typing, marquee boost, scroll bar, cursor */
(() => {
'use strict';
const K = window.Kamo || {};
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const html = document.documentElement;
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
const off = () => reduced || html.classList.contains('no-anim');

class KamoExpand extends HTMLElement {
connectedCallback() {
if (this._i) return; this._i = true;
const panels = $$('.cshow__panel', this);
const hover = this.dataset.trigger === 'hover' && fine;
let cur = Math.max(0, panels.findIndex(p => p.classList.contains('is-active')));
const set = i => { cur = i; panels.forEach((p, k) => { p.classList.toggle('is-active', k === i); p.setAttribute('aria-expanded', String(k === i)); }); };
panels.forEach((p, i) => {
if (hover) p.addEventListener('mouseenter', () => set(i));
p.addEventListener('focusin', () => set(i));
p.addEventListener('click', e => { if (!p.classList.contains('is-active')) { e.preventDefault(); set(i); } });
});
let hov = false;
this.addEventListener('mouseenter', () => hov = true);
this.addEventListener('mouseleave', () => hov = false);
if (this.dataset.auto === 'true' && !off() && panels.length > 1) {
const iv = parseInt(this.dataset.interval, 10) || 4000;
setInterval(() => { if (!hov && !document.hidden && !this.contains(document.activeElement)) set((cur + 1) % panels.length); }, iv);
}
document.addEventListener('shopify:block:select', e => { const i = panels.indexOf(e.target); if (i > -1) set(i); });
}
}
customElements.define('kamo-expand', KamoExpand);

class KamoSearch extends HTMLElement {
connectedCallback() {
if (this._i) return; this._i = true;
const input = $('input[type=search]', this);
const words = (this.dataset.words || '').split('|').map(s => s.trim()).filter(Boolean);
if (!input || !words.length) return;
if (off()) { input.placeholder = words[0]; return; }
let w = 0, c = 0, del = false;
const step = () => {
if (document.activeElement === input || input.value) { setTimeout(step, 800); return; }
const word = words[w];
c += del ? -1 : 1;
input.placeholder = word.slice(0, c) || ' ';
let d = del ? 35 : 70;
if (!del && c === word.length) { del = true; d = 1400; }
else if (del && c === 0) { del = false; w = (w + 1) % words.length; d = 300; }
setTimeout(step, d);
};
step();
}
}
customElements.define('kamo-search', KamoSearch);

function counters(root = document) {
$$('[data-count-to]', root).forEach(el => {
if (el._c) return; el._c = true;
const raw = el.dataset.countTo || '0';
const to = parseFloat(raw) || 0;
const dec = (raw.split('.')[1] || '').length;
const out = $('[data-counter]', el);
if (!out) return;
const fmt = v => v.toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec });
if (off() || !('IntersectionObserver' in window)) { out.textContent = fmt(to); return; }
out.textContent = fmt(0);
const io = new IntersectionObserver(([en], ob) => {
if (!en.isIntersecting) return;
ob.disconnect();
const t0 = performance.now(), dur = 1800;
const tick = n => {
const p = Math.min(1, (n - t0) / dur);
out.textContent = fmt(to * (1 - Math.pow(1 - p, 4)));
if (p < 1) requestAnimationFrame(tick); else out.textContent = fmt(to);
};
requestAnimationFrame(tick);
}, { threshold: 0.5 });
io.observe(el);
});
}

let boostOn = false;
function boost() {
if (boostOn || off()) return;
const hasBoost = () => $$('[data-boost="true"] .marquee__track');
if (!hasBoost().length) return;
boostOn = true;
let last = scrollY, v = 0;
const loop = () => {
const y = scrollY, d = Math.abs(y - last); last = y;
v += (Math.min(d, 90) / 12 - v) * 0.1;
const rate = 1 + v * 1.4;
hasBoost().forEach(t => {
const a = t.getAnimations && t.getAnimations()[0];
if (a && a.updatePlaybackRate) a.updatePlaybackRate(rate);
});
requestAnimationFrame(loop);
};
loop();
}

function progress() {
const bar = $('#ScrollBar');
if (!bar) return;
let tick = false;
const upd = () => {
tick = false;
const max = document.documentElement.scrollHeight - innerHeight;
bar.style.setProperty('--sp', max > 0 ? Math.min(1, scrollY / max).toFixed(4) : 0);
};
addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
addEventListener('resize', upd);
upd();
}

function cursor() {
if (!K.cursor || !fine || off()) return;
const c = document.createElement('div');
c.className = 'kcursor';
c.innerHTML = '<i></i><span></span>';
document.body.appendChild(c);
const label = $('span', c);
let x = -100, y = -100, tx = -100, ty = -100;
addEventListener('pointermove', e => { tx = e.clientX; ty = e.clientY; c.classList.add('is-on'); }, { passive: true });
document.addEventListener('mouseleave', () => c.classList.remove('is-on'));
const loop = () => { x += (tx - x) * 0.22; y += (ty - y) * 0.22; c.style.transform = `translate3d(${x}px,${y}px,0)`; requestAnimationFrame(loop); };
loop();
document.addEventListener('pointerover', e => {
const t = e.target;
const link = t.closest('a,button,summary,label,input,select,textarea');
let txt = '';
if (t.closest('.card,.mcard')) txt = 'View';
else if (t.closest('.cshow__panel:not(.is-active)')) txt = 'Open';
label.textContent = txt;
c.classList.toggle('has-label', !!txt);
c.classList.toggle('is-link', !!link && !txt);
});
}

function init(root = document) { counters(root); boost(); }
document.addEventListener('DOMContentLoaded', () => { progress(); cursor(); init(); });
document.addEventListener('shopify:section:load', e => init(e.target));
})();
